import { CACHE_TAGS } from "@acme/utils/cache-tags";
import { createFileRoute } from "@tanstack/react-router";
import { FilteredArticles } from "~/components/blog/filtered-articles";
import { PageIntro, PageLabel } from "~/components/inside/page-intro";
import { taggedCacheHeaders } from "~/lib/cache-headers";
import { seo } from "~/lib/seo";
import { $getAllPublicArticles } from "~/lib/server/blog";
import {
  generateStructuredDataGraph,
  getBlogListSchemas,
} from "~/lib/structured-data";
import * as m from "~/paraglide/messages.js";
import { getLocale } from "~/paraglide/runtime.js";

export const Route = createFileRoute("/(public)/blog/")({
  component: RouteComponent,
  head: () => {
    const seoData = seo({
      description: m.meta_blog_description(),
      keywords:
        "AI systems, business process automation, human review, small business software, Lindevo writing",
      path: "/blog",
      title: m.meta_blog_title(),
    });
    const structuredData = generateStructuredDataGraph(getBlogListSchemas());

    return {
      links: seoData.links,
      meta: seoData.meta,
      scripts: [
        {
          children: structuredData,
          type: "application/ld+json",
        },
      ],
    };
  },
  headers: taggedCacheHeaders(CACHE_TAGS.blog),
  loader: async () => {
    const articles = await $getAllPublicArticles({
      data: { locale: getLocale() },
    });
    return { articles };
  },
  validateSearch: (search: Record<string, unknown>): { category?: string } => ({
    category:
      typeof search.category === "string" && search.category
        ? search.category
        : undefined,
  }),
});

function RouteComponent() {
  const { articles } = Route.useLoaderData();

  return (
    <div className="wrap">
      {/* No scene band here: the listing itself is the opening, and the export
          heads it with a two-column header on the page ground. */}
      <header className="journal-heading">
        <div>
          <PageLabel>{m.blog_label()}</PageLabel>
          <h1>
            {m.blog_title_1()}
            <br />
            {m.blog_title_2()}
          </h1>
        </div>
        <PageIntro>{m.blog_intro()}</PageIntro>
      </header>

      <FilteredArticles articles={articles} />
    </div>
  );
}
